<template>
  <div class="default-page default-page-center text-center">
    <my-loader v-if="checkingUpdates" label="Проверяем наличие обновлений..." />

    <info-block v-else-if="errCheckUpdates" css-classes="text-danger" icon="bi-x-circle-fill" label="Не удалось проверить обновление">
      <button class="btn btn-primary btn-lg btn-min-width rounded-pill" @click="checkUpdates">Проверить ещё раз</button>
    </info-block>

    <info-block v-else-if="noUpdates" css-classes="text-success" icon="bi-check-circle-fill" label="У вас установлена последняя версия приложения">
      <button class="btn btn-primary btn-lg btn-min-width rounded-pill" @click="checkUpdates">Проверить ещё раз</button>
    </info-block>

    <info-block v-else-if="hasUpdates" css-classes="text-success" icon="bi-cloud-arrow-down-fill" :label="`Выпущена новая версия: ${lastVersion}`">
      <a @click="fallbackDownloadApp" class="btn btn-primary btn-lg btn-min-width rounded-pill">Скачать {{ lastVersion }}</a>
    </info-block>

    <my-loader v-else-if="downloadingUpdates" label="Скачиванием новую версию приложения..." />

    <info-block v-else-if="errDownloadUpdates" css-classes="text-danger" icon="bi-x-circle-fill" label="Не удалось скачать новую версию приложения.<br>Пожалуйста попробуйте скачать обновление вручную:">
      <a @click="downloadApp" class="btn btn-secondary btn-lg btn-min-width rounded-pill mb-3">Попробовать ещё раз</a>
      <br>
      <a @click="fallbackDownloadApp" class="btn btn-primary btn-lg btn-min-width rounded-pill">Скачать вручную</a>
    </info-block>

    <info-block v-else-if="updatesDownloaded" css-classes="text-success" icon="bi-cloud-check-fill" :label="`Версия ${lastVersion} готова к установке на телефон:`">
      <a @click="installApp" class="btn btn-primary btn-lg btn-min-width rounded-pill">Установить</a>
    </info-block>

    <div v-else>
      <button class="btn btn-primary btn-lg btn-min-width rounded-pill" @click="checkUpdates">Проверить обновление</button>
    </div>

    <div class="mt-4">
      <span class="text-secondary">Текущая версия:</span> {{ curVersion }}
    </div>
  </div>
</template>

<script>
import * as appConf from '@/../package.json';
import Api from '@/libraries/Api';
import semver from 'semver';
import EnvConfig from "@/env";

export default {
  name: 'CheckUpdates',
  data() {
    return {
      curVersion: '',
      lastVersion: '',
      noUpdates: false,
      hasUpdates: false,
      errCheckUpdates: false,
      checkingUpdates: false,
      downloadingUpdates: false,
      errDownloadUpdates: false,
      updatesDownloaded: false,
    }
  },
  created() {
    this.curVersion = appConf?.version || '';
  },
  methods: {
    async checkUpdates() {
      this.errCheckUpdates = false;
      this.noUpdates = false;
      this.hasUpdates = false;
      this.checkingUpdates = true;

      try {
        this.lastVersion = await Api.get('get_last_app_version');
        semver.gt(this.lastVersion, this.curVersion)
            ? (this.hasUpdates = true)
            : (this.noUpdates = true);
      } catch (e) {
        this.errCheckUpdates = true;
      }
      this.checkingUpdates = false;
    },

    fallbackDownloadApp() {
      return cordova.InAppBrowser.open(
          EnvConfig.SITE_ROOT_URL + 'get_app?secretCode=Sid1o8dXYDG17dhasigAGFOdvuaid',
          '_system',
          'location=yes'
      );
    },

    async downloadApp() {
      const apkName = `kkosa_tasks_${this.lastVersion}.apk`;
      const apkURL  = EnvConfig.SITE_ROOT_URL + 'get_app?secretCode=Sid1o8dXYDG17dhasigAGFOdvuaid';
      // const saveTo  = `${cordova.file.externalRootDirectory}download/${apkName}`;
      // const getDirectory = (path) => { // Функция для доступа к файловой системе
      //   return new Promise((resolve, reject) => {
      //     window.resolveLocalFileSystemURL(path, resolve, reject);
      //   });
      // }
      // const getFile = (dirEntry, fileName) => {
      //   return new Promise((resolve, reject) => {
      //     dirEntry.getFile(fileName, { create: true }, resolve, reject);
      //   });
      // }
      // function getDownloadsDirectory() {
      //   return new Promise((resolve, reject) => {
      //     window.resolveLocalFileSystemURL(cordova.file.externalRootDirectory + "Download/", resolve, reject);
      //   });
      // }
      // const writeFile = (fileEntry, data) => {
      //   alert('file to write data: ' + JSON.stringify(fileEntry) );
      //   return new Promise((resolve, reject) => {
      //     fileEntry.createWriter((fileWriter) => {
      //       fileWriter.onwriteend = resolve;
      //       fileWriter.onerror = reject;
      //       fileWriter.write(data);
      //
      //       // const blob = new Blob([data], { type: "text/plain" });
      //       // fileWriter.write(blob);
      //     }, reject);
      //   });
      // }
      // Асинхронная функция для получения доступа к папке Downloads
      async function getDownloadsDirectory() {
        return new Promise((resolve, reject) => {
          window.resolveLocalFileSystemURL(cordova.file.externalRootDirectory + "Download/", resolve, reject);
        });
      }

      // Асинхронная функция для создания или открытия файла
      async function getFile(dirEntry, fileName) {
        return new Promise((resolve, reject) => {
          dirEntry.getFile(
              fileName,
              { create: true, exclusive: false },
              resolve,
              reject
          );
        });
      }

      // Асинхронная функция для записи данных в файл
      async function writeFile(fileEntry, content) {
        return new Promise((resolve, reject) => {
          fileEntry.createWriter((fileWriter) => {
            fileWriter.onwriteend = resolve;
            fileWriter.onerror = reject;

            const blob = new Blob([content], { type: "text/plain" });
            fileWriter.write(blob);
          });
        });
      }
      const onError = () => {
        this.errDownloadUpdates = true;
      }
      const onSuccess = async response => {
        this.updatesDownloaded = true;

        const blob = await response.blob();
        // const dirEntry = await getDirectory(cordova.file.dataDirectory);
        alert('filesize=' + blob.size);

        let dirEntry = null;
        try {
          dirEntry = await getDownloadsDirectory();
          alert("Существует каталог с таким именем:" + dirEntry.fullPath);
        } catch (error) {
          if (error.code === 1) { // NOT_FOUND_ERR
            alert("Каталог не найден, продолжаем создавать файл.");
          } else {
            alert("Ошибка проверки каталога:" + JSON.stringify(error));
          }
        }
        // alert('dirEntry=' + JSON.stringify(dirEntry));

        let fileEntry = null;
        try {
          fileEntry = await getFile(dirEntry, apkName);
          alert("Файл уже существует:", fileEntry.fullPath);
        } catch (error) {
          if (error.code === 1) { // NOT_FOUND_ERR
            alert("Файл не найден, можно создавать.");
          } else {
            alert("Ошибка проверки файла:" + JSON.stringify(error));
          }
        }

        alert('fileEntry=' + JSON.stringify(fileEntry));
        await writeFile(fileEntry, blob);
        alert("Файл сохранён в папку Downloads: " + fileEntry.fullPath);
      }

      // Код самой ф-ии:
      this.updatesDownloaded = false;
      this.errDownloadUpdates = false;
      this.downloadingUpdates = false;

      try {
        alert('try update');
        this.downloadingUpdates = true;
        // console.log('apkURL=', encodeURI(apkURL));
        const response = await fetch(encodeURI(apkURL));
        // console.log('RESPONSE=', response)
        if (!response.ok) {
          throw new Error(`Ошибка загрузки apk-файла: ${response.statusText}`);
        }
        await onSuccess(response);
        alert('success block done');
      } catch (e) {
        console.error('CheckUpdatesPage::downloadApp get error: ', e.message);
        alert('CheckUpdatesPage::downloadApp get error: ' + JSON.stringify(e));
        onError();
        alert('error block done');
      } finally {
        alert('finally block done!');
        this.downloadingUpdates = false;
      }
    },

    installApp() {

    }
  },
}
</script>

<style lang="scss" scoped>
.about-updates-block {
  padding-left: 15px;
  padding-right: 15px;

  &-icon {
    font-size: 60px;
    line-height: 1;
  }

  &-info {
    padding-top: 15px;
    padding-bottom: 30px;
  }
}
</style>